// @greenlight-spec: 10-security-compliance.md
// @greenlight-spec: 16-api-conventions.md
import { z } from 'zod';
/**
 * One SSO provider the org has configured, as surfaced to the unauthenticated
 * sign-in page (docs/10 §Login flow). `login_url` is the OIDC initiator the
 * "Sign in" button navigates to — never IdP config internals or secret material.
 */
export const SsoProviderSchema = z.object({
    type: z.enum(['entra', 'okta', 'google', 'oidc']),
    display_name: z.string().min(1),
    login_url: z.string().min(1),
});
/**
 * Response of `GET /auth/providers`. Deliberately a plural array carrying a
 * single element at MVP (single-IdP installs): the post-MVP multi-IdP extension
 * adds elements with no contract change. Empty when no IdP is configured yet.
 */
export const SsoProvidersResponseSchema = z.object({
    providers: z.array(SsoProviderSchema),
});
//# sourceMappingURL=auth.js.map